import React from 'react';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { StatusSummary } from './activityprogramme.models';
import { formatMoney, formatNumber } from './activityprogramme.normalizers';

type Props = { rows: StatusSummary[] };

const StatusSummaryPanel: React.FC<Props> = ({ rows }) => (
  <Paper elevation={1} sx={{ p: 2 }}>
    <Typography variant="h6" sx={{ mb: 2 }}>Status Summary</Typography>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell>Status</TableCell>
          <TableCell align="right">Activities</TableCell>
          <TableCell align="right">Initial</TableCell>
          <TableCell align="right">Revised</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => (
          <TableRow key={row.statuscode || row.statusname}>
            <TableCell>{row.statusname || row.statuscode}</TableCell>
            <TableCell align="right">{formatNumber(row.activities)}</TableCell>
            <TableCell align="right">{formatMoney(row.plannedamount)}</TableCell>
            <TableCell align="right">{formatMoney(row.revisedamount)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Paper>
);

export default StatusSummaryPanel;
